import { IGlucoseTimeInRange } from "../../../@types/Measurements";

export type TimeInRangeBand = keyof IGlucoseTimeInRange;

// EN-5232: bands are classified server-side (GlucoseTimeInRange). These are only the
// labels shown for them, per unit, as listed in the ticket.
const LEVELS: Record<"mmol/L" | "mg/dL", Record<TimeInRangeBand, string>> = {
  "mmol/L": {
    veryHigh: ">13.9",
    high: ">10.0",
    inRange: "3.9 - 10.0",
    low: "<3.9",
    veryLow: "<3.0",
  },
  "mg/dL": {
    veryHigh: ">250",
    high: ">180",
    inRange: "70 - 180",
    low: "<70",
    veryLow: "<54",
  },
};

// shortcut: shown as text only, percentages always use the standard range. Needs a
// per-patient flag if clinicians want pregnancy bands calculated.
const PREGNANCY_IN_RANGE_LEVELS = {
  "mmol/L": "3.8 - 7.8",
  "mg/dL": "68.4 - 140",
};

/** Top to bottom, as stacked in the bar. */
export const TIME_IN_RANGE_BANDS: {
  band: TimeInRangeBand;
  labelKey: string;
}[] = [
  { band: "veryHigh", labelKey: "chart_timeInRange_veryHigh" },
  { band: "high", labelKey: "chart_timeInRange_high" },
  { band: "inRange", labelKey: "chart_timeInRange_inRange" },
  { band: "low", labelKey: "chart_timeInRange_low" },
  { band: "veryLow", labelKey: "chart_timeInRange_veryLow" },
];

export function getGlucoseUnit(preference?: string): "mmol/L" | "mg/dL" {
  return preference === "mg/dL" ? "mg/dL" : "mmol/L";
}

export function getTimeInRangeLevel(
  band: TimeInRangeBand,
  unit: "mmol/L" | "mg/dL"
) {
  return `${LEVELS[unit][band]} ${unit}`;
}

export function getPregnancyInRangeLevel(unit: "mmol/L" | "mg/dL") {
  return `${PREGNANCY_IN_RANGE_LEVELS[unit]} ${unit}`;
}

/** Whole percent, except a band with any time in it never reads as 0%. */
export function formatTimeInRangePercent(percent: number) {
  if (percent <= 0) return "0%";
  if (percent < 1) return "<1%";

  return `${Math.round(percent)}%`;
}
